import FormattedMessage from 'I18n/components/FormattedMessage';
import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import { View } from 'foundations-components/components/View';
import { useIsCopilotWidgetActive } from 'copilot-toolkit/hooks/useIsCopilotWidgetActive';
import { useIsUngatedForBreezeRebrand } from 'ai-components-ui-library/hooks/useIsUngatedForBreezeRebrand';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CopilotPreviewActions = ({
  messages,
  aiTracker,
  disabled,
  onChatWithCopilot,
  showCloseButton,
  showAskAQuestionButton,
  onCloseButtonClick
}) => {
  const message = messages.length > 0 ? messages[0] : null;
  const threadId = message && 'threadId' in message ? message.threadId : null;
  const isCopilotReady = useIsCopilotWidgetActive();
  const isUngatedForBreezeRebrand = useIsUngatedForBreezeRebrand();
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "400",
    as: "div",
    children: [showCloseButton && onCloseButtonClick && /*#__PURE__*/_jsx(AIButton, {
      disabled: disabled,
      onClick: onCloseButtonClick,
      showBreezeIcon: false,
      size: "xs",
      use: "tertiary",
      usageTracker: aiTracker,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "aiAddonCopilotPreview.components.copilotPreview.closeButton"
      })
    }), showAskAQuestionButton && /*#__PURE__*/_jsx(AIButton, {
      onClick: () => {
        if (onChatWithCopilot) {
          onChatWithCopilot({
            threadId
          });
        }
      },
      disabled: disabled || !isCopilotReady,
      tooltip: isUngatedForBreezeRebrand ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "aiAddonCopilotPreview.components.copilotPreview.chatWithCopilotButton.tooltipAssistant"
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "aiAddonCopilotPreview.components.copilotPreview.chatWithCopilotButton.tooltip"
      }),
      size: "xs",
      use: "secondary",
      usageTracker: aiTracker,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "aiAddonCopilotPreview.components.copilotPreview.chatWithCopilotButton.message"
      })
    })]
  });
};